import { Record } from 'immutable';

export default Record({
    active: true,
    asin: '',
    expiresAt: null,
    id: null,
    keyword: '',
    previousRanking: null,
    productId: null,
    ranking: null,
});




// WEBPACK FOOTER //
// ./src/records/keyword.js